export const stateChart = (arrayOptions) => {
  let arraySeries = [];
  let arrayLabels = [];

  arrayOptions.map((opt) => arraySeries.push(0));
  arrayOptions.map((opt) => arrayLabels.push(opt));

  return {
    series: arraySeries,
    options: {
      //color: ["#00AB55", "#2D99FF", "#FFE700", "#826AF9"],
      //colors: ["#C9E3FE", "#f6d1de", "#fdf9c4", "#ffda9e", "#dfcae1", "#cfffca" ], //COLORES PASTELES
      colors: ["#4fa8fb", "#ff6961", "#8ae287", "#b695c0", "#f3aacb", "#ffb888","#c5c6c8" ], //COLORES PASTELES
      chart: {
        width: 380,
        type: 'pie',
      },
      labels: arrayLabels,
      responsive: [
        {
          breakpoint: 580,
          options: {
            chart: {
              width: 200,
            },
            legend: {
              position: 'bottom',
            },
          },
        },
      ],
    },
  };
};
